import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/services/store";
import { passwordRecoverySelectors } from "../password-recovery-slice";
import { passwordRecoveryTitlesMap } from "../constants";
import { PasswordRecoverySteps } from "../types";

export const usePasswordRecoveryContent = () => {
  const { t } = useTranslation();
  const step = useAppSelector(passwordRecoverySelectors.selectStep);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const title = t(`passwordRecoveryPage.${passwordRecoveryTitlesMap[step]}`);

  const subtitle =
    step === PasswordRecoverySteps.NEW_PASSWORD_STEP && width > 600
      ? t("registrationPage.userInfoStep.passwordMustContain")
      : undefined;

  const hideTitle = step === PasswordRecoverySteps.SUCCESS_STEP && width < 601;

  return {
    step,
    title,
    subtitle,
    hideTitle,
  };
};
